<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Report-Export-View",
  path: "view",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
